module.exports = __webpack_public_path__ + "static/images/ph.-6pn9DA.svg";